import { Link, Stack, Typography } from '@mui/material';
import { CopyToClipboardButton } from '@/components/CopyToClipboardButton';
import { DisabledChip } from '@/components/DisabledChip';
import { DISABLED_TEXT_SX } from '@/components/disabledStyle';

export interface HostUrlProps {
  hostname: string;
  clickable: boolean;
  /** SASADM-0170 — the host's public app is turned off: struck-through text, never a link. */
  disabled?: boolean;
}

/** A host's https URL: a new-tab link when `clickable`, plain text otherwise; always copyable. */
export function HostUrl({ hostname, clickable, disabled = false }: HostUrlProps) {
  const url = `https://${hostname}`;
  const sx = { fontFamily: 'monospace', wordBreak: 'break-all' } as const;
  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
      {disabled ? (
        <>
          <Typography variant="body2" sx={{ ...sx, ...DISABLED_TEXT_SX }}>
            {url}
          </Typography>
          <DisabledChip />
        </>
      ) : clickable ? (
        <Link href={url} target="_blank" rel="noopener noreferrer" variant="body2" sx={sx}>
          {url}
        </Link>
      ) : (
        <Typography variant="body2" sx={sx}>
          {url}
        </Typography>
      )}
      <CopyToClipboardButton value={url} />
    </Stack>
  );
}
